<template>
    <div class="select-page">
    
        <div class="seach-bar">

            <div class="container-svg-serach">
                <svg xmlns="http://www.w3.org/2000/svg" width="21" height="21" viewBox="0 0 21 21" fill="none">
                    <path d="M17.0625 8.53125C17.0625 10.4139 16.4514 12.1529 15.4219 13.5639L20.6145 18.7605C21.1271 19.2732 21.1271 20.1059 20.6145 20.6186C20.1018 21.1312 19.2691 21.1312 18.7564 20.6186L13.5639 15.4219C12.1529 16.4555 10.4139 17.0625 8.53125 17.0625C3.81855 17.0625 0 13.2439 0 8.53125C0 3.81855 3.81855 0 8.53125 0C13.2439 0 17.0625 3.81855 17.0625 8.53125ZM8.53125 14.4375C9.30687 14.4375 10.0749 14.2847 10.7915 13.9879C11.5081 13.6911 12.1592 13.256 12.7076 12.7076C13.256 12.1592 13.6911 11.5081 13.9879 10.7915C14.2847 10.0749 14.4375 9.30687 14.4375 8.53125C14.4375 7.75563 14.2847 6.9876 13.9879 6.27103C13.6911 5.55445 13.256 4.90335 12.7076 4.3549C12.1592 3.80645 11.5081 3.3714 10.7915 3.07459C10.0749 2.77777 9.30687 2.625 8.53125 2.625C7.75563 2.625 6.98761 2.77777 6.27103 3.07459C5.55445 3.3714 4.90335 3.80645 4.3549 4.3549C3.80645 4.90335 3.3714 5.55445 3.07459 6.27103C2.77777 6.9876 2.625 7.75563 2.625 8.53125C2.625 9.30687 2.77777 10.0749 3.07459 10.7915C3.3714 11.5081 3.80645 12.1592 4.3549 12.7076C4.90335 13.256 5.55445 13.6911 6.27103 13.9879C6.98761 14.2847 7.75563 14.4375 8.53125 14.4375Z" fill="#E3D2EE"/>
                </svg>
            </div>
            <input v-model="valueInputSearch">
            <i class="fa-solid fa-bars-filter" @click="showFilter"></i>

            <div class="container-filter" ref="filterSelectPage" v-if="displayFilter">
                <div class="filter">
                    <div class="container-title">
                        <h5>Type de compte</h5>
                        <p v-if="Object.keys(Networks).length == SelectNetwork.length" @click="removeAllNetwork">Tout masquer</p>
                        <p v-else @click="addAllNetwork">Tout afficher</p>
                    </div>
                    <div class="list-reseaux">
                        <div class="reseau" v-for="(networkKey,index) in Object.keys(Networks)" :key="index">
                            <Checkbox :isChecked="SelectNetwork.includes(networkKey)" :add="addNetwork" :remove="removeNetwork" :id="'FilterSelectPage-'+networkKey"></Checkbox>
                            <img :src="Networks[networkKey].urlPicture">
                            <p>{{ Networks[networkKey].label}}</p>
                        </div>    
                    </div>
                </div>
            </div>
        </div>
      
        <div class="container-list">
             <details>
                <summary>
                    <Checkbox :isChecked="SelectPage.length >= 1" :isLine="SelectPage.length < getAllIdPagesWithFilter().length && SelectPage.length >= 1" :isDisable="getAllIdPagesWithFilter().length == 0" :add="addAllPage" :remove="removeAllPage" :id="'addAllPage'"></Checkbox>
                    <p>Toutes les pages</p>
                </summary>
            </details>
            <!-- //task clement modifier le localstorage pour prendre en compte le statut de groupe (open ou close) -->
            <!-- <details v-for="group in groups" v-if="!groupIsEmpty(group.id)" :key="group.id" :open="valueInputSearch !== ''">  -->
            <details v-for="group in groups.filter(g => !groupIsEmpty(g.id))" :key="group.id" :open="valueInputSearch !== ''"> 
                <summary>
                    <Checkbox :isChecked="groupIsChecked(group.id)" :isLine="allPagesInGroupIsChecked(group.id)" :add="addSelectGroup" :remove="removeSelectGroup" :id="group.id"></Checkbox>
                    <p>{{group.name}}</p>
                    <i class="fa-solid fa-caret-right"></i>
                </summary>

                <!-- <label class="pages" v-for="page in allPages" v-if="group.pages.includes(page.id) && isPageMatchingFilter(page.id)" :key="page.id"> -->
                <label class="pages" v-for="page in allPages.filter(p => group.pages.includes(p.id) && isPageMatchingFilter(p.id))" :key="page.id">
                    <Avatar :urlPicture="page.avatar" :typeNetwork="page.network" :checked="SelectPage.includes(page.id)"></Avatar>
                    
                    <Tooltip :text="page.name" :condition="(element)=>(element.querySelector('p').offsetWidth < element.querySelector('p').scrollWidth)">
                        <p class="selectDisable">{{page.name}}</p>
                    </Tooltip>
                    
                    <Checkbox :isChecked="SelectPage.includes(page.id)" :add="addSelectPage" :remove="removeSelectPage" :id="page.id"></Checkbox>
                </label>
            </details>

            <!-- <label class="otherPage" v-for="page in allPages" v-if="!pageInGroup(page.id) && isPageMatchingFilter(page.id)" :key="page.id"> -->
            <label class="otherPage" v-for="page in allPages.filter(p => !pageInGroup(p.id) && isPageMatchingFilter(p.id))" :key="page.id">
                <Avatar :urlPicture="page.avatar" :typeNetwork="page.network" :checked="SelectPage.includes(page.id)"></Avatar>

                <Tooltip :text="page.name" :condition="(element)=>(element.querySelector('p').offsetWidth < element.querySelector('p').scrollWidth)">
                    <p class="selectDisable">{{page.name}}</p>
                </Tooltip>

                <Checkbox :isChecked="SelectPage.includes(page.id)" :add="addSelectPage" :remove="removeSelectPage" :id="page.id"></Checkbox>
            </label>
       
        </div>
    </div>
</template>

<script>
import Checkbox from './utils/checkbox.vue';
import Avatar from './utils/avatar.vue';
import Tooltip from './tooltip/tooltipInit.vue';

export default {
    name: 'selectPage',

    components: {
        Checkbox,
        Avatar,
        Tooltip
    },

    props: {
        groups : {
            type: Array,
            default() {
                return []
            }
        },

        allPages : {
            type: Array,
            default() {
                return []
            }
        },

        SelectPageProp : {
            type: Array,
            default() {
                return []
            }
        },
    },

    data() {
        return {
            SelectNetwork : ['facebook','linkedin','pagesFacebook','tiktok','google','youtube','instagram','pinterest','twitter','telegram', 'threads', 'whatsapp'],
            displayFilter : false,
            valueInputSearch : "",
            
            Networks: {
                'facebook' : {
                    label : "Facebook",
                    urlPicture : require('../../assets/img/iconsNetwork/ico-facebook.png')
                },
                // 'groupesFacebook' : {
                //     label : "Groupes",
                //     urlPicture : require('../../assets/img/iconsNetwork/ico-facebook.png')
                // },
                'linkedin' : {
                    label : "Linkedin",
                    urlPicture : require('../../assets/img/iconsNetwork/ico-linkedin.png')
                },
                'pagesFacebook' : {
                    label : "Pages",
                    urlPicture : require('../../assets/img/iconsNetwork/ico-facebook.png')
                },
                'tiktok' : {
                    label : "Tiktok",
                    urlPicture : require('../../assets/img/iconsNetwork/ico-tiktok.png')
                },
                'google' : {
                    label : "My business",
                    urlPicture : require('../../assets/img/iconsNetwork/ico-google.png')
                },
                'youtube' : {
                    label : "Youtube",
                    urlPicture : require('../../assets/img/iconsNetwork/ico-youtube.png')
                },
                'threads' : {
                    label : "Threads",
                    urlPicture : require('../../assets/img/iconsNetwork/ico-threads.png')
                },
                'whatsapp' : {
                    label : "Whatsapp",
                    urlPicture : require('../../assets/img/iconsNetwork/ico-whatsapp.png')
                },
                'instagram' : {
                    label : "Instagram",
                    urlPicture : require('../../assets/img/iconsNetwork/ico-instagram.png')
                },
                'pinterest' : {
                    label : "Pinterest",
                    urlPicture : require('../../assets/img/iconsNetwork/ico-pinterest.png')
                },
                'twitter' : {
                    label : "Twitter",
                    urlPicture : require('../../assets/img/iconsNetwork/ico-twitter.png')
                },
                'telegram' : {
                    label : "Telegram",
                    urlPicture : require('../../assets/img/iconsNetwork/ico-telegram.png')
                },
            },

            SelectPage : []
        };
    },

    watch : {
        SelectPageProp() {
            this.SelectPage = this.SelectPageProp
        }
    },

    mounted () {
        this.SelectPage = this.SelectPageProp
    },

    methods: {
        findPage(pageId) {
            let page = this.allPages.find(p => p.id == pageId)
            return page && page ? page : null
        },

        findGroup(idGroup) {
            let group = this.groups.find(g => g.id == idGroup)
            return group ? group : null
        },

        getAllIdPagesWithFilter() {
            return this.allPages.filter(page => this.isPageMatchingFilter(page.id)).map(page => page.id);
        },
       
        pageInGroup(pageId) {
            return this.groups.find(g => g.pages.includes(pageId))
        },
        
        groupIsEmpty(idGroup) {
            let group = this.findGroup(idGroup);
            return !group.pages.some(idPage => (
                this.allPages.some(page => page.id == idPage && this.isPageMatchingFilter(idPage))
            ))
        },

        isPageMatchingFilter(pageId) {
            let page = this.findPage(pageId);
            return this.SelectNetwork.includes(page.network) && 
            (page.name.trim().toLowerCase().indexOf(this.valueInputSearch.trim().toLowerCase()) >= 0 ||
            page.network.indexOf(this.valueInputSearch.trim().toLowerCase()) >= 0);
        },

        //verfify si au moins une page est select 
        groupIsChecked(idGroup) {
           return this.findGroup(idGroup).pages.some(pageId => this.SelectPage.includes(pageId));
        },
        
        //verfify si toute les pages est select 
        allPagesInGroupIsChecked(idGroup) {
            return this.findGroup(idGroup).pages.some(pageId => !this.SelectPage.includes(pageId) && this.findPage(pageId) && this.isPageMatchingFilter(pageId));
        },

        isEllipsisActive(elmt) {
            console.log("isEllipsisActive",elmt)
            return true
        },

        //EVENT CHECKBOX list Page & Group
        addAllPage() {
            this.SelectPage = this.allPages
            .filter(page => this.isPageMatchingFilter(page.id))
            .map(page => page.id);

            this.$emit('updateSelectPage', this.SelectPage)
        },
  
        removeAllPage() {
            this.SelectPage = []
            this.$emit('updateSelectPage', this.SelectPage)
        },

        addSelectPage(idPage) {
            if(!this.SelectPage.includes(idPage)) {
                this.SelectPage.push(idPage)
                this.$emit('updateSelectPage', this.SelectPage)
            }
        },

        removeSelectPage(idPage) {
            this.SelectPage = this.SelectPage.filter(id => id !== idPage)
            this.$emit('updateSelectPage', this.SelectPage)
        },
        
        addSelectGroup(idGroup) {
            const group = this.findGroup(idGroup);
            const pagesToAdd = group.pages.filter(idPage => !this.SelectPage.includes(idPage) && this.findPage(idPage) && this.isPageMatchingFilter(idPage));
            this.SelectPage.push(...pagesToAdd);
        },

        removeSelectGroup(idGroup) {
            const pagesGroup = this.findGroup(idGroup).pages;
            this.SelectPage = this.SelectPage.filter(idPage => !pagesGroup.includes(idPage));
            this.$emit('updateSelectPage', this.SelectPage)
        },

        //EVENT Filter
        addAllNetwork() {
            this.SelectNetwork = Object.keys(this.Networks);
        },
        removeAllNetwork() {
            this.SelectNetwork = [];
        },
        addNetwork(name) {
            name = name.split('-')[1]  // name FilterSelectPage-linkedin or FilterSelectPage-instagram ...
            if(!this.SelectNetwork.includes(name)) {
                this.SelectNetwork.push(name)
            }
        },
        removeNetwork(name) {
            this.SelectNetwork = this.SelectNetwork.filter(nameNetwork => nameNetwork !== name.split('-')[1])
        },
        showFilter(e) {
            e.stopPropagation();
            this.displayFilter = true;
            window.addEventListener("click", this.handleClickOutside);
        },
        handleClickOutside(event) {
            const targetElement = this.$refs.filterSelectPage;
            if (!targetElement.contains(event.target)) {
                window.removeEventListener("click", this.handleClickOutside, false);
                this.displayFilter = false;
            }
        },
    },


    beforeDestroy() {
        window.removeEventListener("click", this.handleClickOutside);
    },
};
</script>